import React, { Component } from 'react';
import cx from 'classnames';
import { connect } from 'react-redux';
import { getLogger } from '@cld/upload-widget';
import { asAbsolute } from 'root/routes/utils';
import bindRootActions, { types as rootAts } from 'root/actions';
import { getComponentConsumer } from 'root/components/UploadContainer/uploaderContext';
import { selectIsThinMenu } from 'root/selectors';

const logger = getLogger();

const isRootMatch = (route, options) => options.root && route.location.pathname === asAbsolute(options.id);

const getClassNameForActivePanel = ({ route }, options) =>
  (route.match && route.match.isExact) || isRootMatch(route, options) || route.location.pathname.indexOf(asAbsolute(options.id)) === 0 ? 'active' : '';

export default (options) => (Panel) => {
  class TabPanelHoc extends Component {
    componentDidMount() {
      this.updateUploaderSource();
    }

    componentDidUpdate() {
      this.updateUploaderSource();
    }

    addToUploadQueue = (data) => {
      logger.log('[TabPanel]: adding file data to upload queue');

      this.props.rootActions[rootAts.ADD_UPLOAD_TO_QUEUE]({
        files: data.files,
      });
    };

    updateUploaderSource() {
      if (!options.root || isRootMatch(this.props.route, options)) {
        logger.log(`[TabPanel]: setting uploader source to: ${options.id}`);
        this.props.uploader.setCurrentSource(options.id);
        this.props.rootActions[rootAts.SET_ACTIVE_SOURCE]({ source: options.id });
      }
    }

    render() {
      const cls = cx(
        'panel',
        'content-wrap',
        'bg-source-bg bg-source-bg-c',
        options.id,
        'h-100 h-auto-ns',
        getClassNameForActivePanel(this.props, options),
        'flex',
        'items-center',
        { 'thin-menu': this.props.isThinMenu }
      );

      return (
        <div className={cls}>
          <Panel {...this.props} addToUploadQueue={this.addToUploadQueue} />
        </div>
      );
    }
  }

  TabPanelHoc.displayName = `TabPanelHOC(${options.id})`;

  return connect(
    (state) => ({ isThinMenu: selectIsThinMenu(state) }),
    (dispatch) => ({
      rootActions: bindRootActions(dispatch),
    })
  )(getComponentConsumer(TabPanelHoc));
};
